

















































import Vue from "vue";
import { CMSType } from "@/types";

export default Vue.extend({
  name: "CmsIcon",

  props: {
    cms: { type: String, required: true },
    active: { type: Boolean, default: true },
  },

  computed: {
    isWordpress(): boolean {
      return this.cms === CMSType.WORDPRESS;
    },

    isShopify(): boolean {
      return this.cms === CMSType.SHOPIFY;
    },

    isLightspeed(): boolean {
      return this.cms === CMSType.LIGHTSPEED;
    },

    isApi(): boolean {
      return this.cms === CMSType.API;
    },
  },
});
